export interface Product {
  id: number;
  name: string;
  brand: string;
  price: number;
  originalPrice?: number;
  discount?: number;
  rating: number;
  reviewCount: number;
  image: string;
  isNew?: boolean;
  isBestSeller?: boolean;
  isInStock: boolean;
  description: string;
  category: string;
}

export const sampleProducts: Product[] = [
  {
    id: 1,
    name: "Vitamin D3 5000 IU Softgels",
    brand: "Nature Made",
    price: 12.99,
    originalPrice: 16.99,
    discount: 24,
    rating: 4.5,
    reviewCount: 2847,
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=400&fit=crop&crop=center",
    isBestSeller: true,
    isInStock: true,
    description: "High potency Vitamin D3 to support bone health and immune function. Easy-to-swallow softgels.",
    category: "vitamins"
  },
  {
    id: 2,
    name: "Omega-3 Fish Oil 1000mg",
    brand: "Nordic Naturals",
    price: 24.99,
    originalPrice: 29.99,
    discount: 17,
    rating: 4.7,
    reviewCount: 1923,
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=400&fit=crop&crop=center",
    isNew: true,
    isInStock: true,
    description: "Premium fish oil with high concentration of EPA and DHA for heart and brain health.",
    category: "supplements"
  },
  {
    id: 3,
    name: "Probiotics 50 Billion CFU",
    brand: "Garden of Life",
    price: 34.99,
    rating: 4.6,
    reviewCount: 1456,
    image: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=400&fit=crop&crop=center",
    isBestSeller: true,
    isInStock: true,
    description: "Advanced probiotic formula with 50 billion live cultures to support digestive health.",
    category: "supplements"
  },
  {
    id: 4,
    name: "Vitamin C 1000mg Tablets",
    brand: "Nature's Bounty",
    price: 8.99,
    originalPrice: 12.99,
    discount: 31,
    rating: 4.4,
    reviewCount: 3241,
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=400&fit=crop&crop=center",
    isInStock: true,
    description: "High potency Vitamin C tablets to support immune system and antioxidant protection.",
    category: "vitamins"
  },
  {
    id: 5,
    name: "Collagen Peptides Powder",
    brand: "Vital Proteins",
    price: 42.99,
    rating: 4.8,
    reviewCount: 987,
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=400&fit=crop&crop=center",
    isNew: true,
    isInStock: true,
    description: "Grass-fed collagen peptides powder for healthy skin, hair, and joint support.",
    category: "supplements"
  },
  {
    id: 6,
    name: "Multivitamin for Women",
    brand: "Centrum",
    price: 15.99,
    originalPrice: 19.99,
    discount: 20,
    rating: 4.3,
    reviewCount: 2156,
    image: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=400&fit=crop&crop=center",
    isInStock: true,
    description: "Complete multivitamin formula designed specifically for women's nutritional needs.",
    category: "vitamins"
  },
  {
    id: 7,
    name: "Magnesium Glycinate 400mg",
    brand: "Doctor's Best",
    price: 18.99,
    rating: 4.6,
    reviewCount: 1234,
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=400&fit=crop&crop=center",
    isInStock: true,
    description: "Highly absorbable magnesium glycinate for muscle relaxation and sleep support.",
    category: "supplements"
  },
  {
    id: 8,
    name: "Biotin 10000mcg Tablets",
    brand: "Nature's Bounty",
    price: 11.99,
    originalPrice: 15.99,
    discount: 25,
    rating: 4.2,
    reviewCount: 1876,
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=400&fit=crop&crop=center",
    isInStock: false,
    description: "High potency biotin tablets to support healthy hair, skin, and nails.",
    category: "vitamins"
  },
  {
    id: 9,
    name: "Turmeric Curcumin 95%",
    brand: "NOW Foods",
    price: 22.99,
    rating: 4.5,
    reviewCount: 987,
    image: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=400&fit=crop&crop=center",
    isBestSeller: true,
    isInStock: true,
    description: "Standardized turmeric extract with 95% curcuminoids for anti-inflammatory support.",
    category: "supplements"
  },
  {
    id: 10,
    name: "Vitamin B12 5000mcg",
    brand: "Jarrow Formulas",
    price: 16.99,
    originalPrice: 21.99,
    discount: 23,
    rating: 4.4,
    reviewCount: 1456,
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=400&fit=crop&crop=center",
    isInStock: true,
    description: "High potency Vitamin B12 in methylcobalamin form for energy and nerve health.",
    category: "vitamins"
  },
  {
    id: 11,
    name: "CoQ10 200mg Softgels",
    brand: "Qunol",
    price: 29.99,
    rating: 4.7,
    reviewCount: 756,
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=400&fit=crop&crop=center",
    isNew: true,
    isInStock: true,
    description: "Water-soluble CoQ10 for enhanced absorption and cardiovascular support.",
    category: "supplements"
  },
  {
    id: 12,
    name: "Zinc 50mg Tablets",
    brand: "Nature Made",
    price: 9.99,
    originalPrice: 13.99,
    discount: 29,
    rating: 4.3,
    reviewCount: 2134,
    image: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=400&fit=crop&crop=center",
    isInStock: true,
    description: "Essential zinc mineral for immune system support and wound healing.",
    category: "vitamins"
  }
];

export const featuredProducts = sampleProducts.filter(product => product.isBestSeller);
export const newProducts = sampleProducts.filter(product => product.isNew);
export const onSaleProducts = sampleProducts.filter(product => product.discount && product.discount > 0);
